import React from "react";
import clsx from "clsx";
import PhoneLink from "../../laco-common/components/PhoneLink";
import { formatPhoneNumber } from "../../utils";

type PhoneLinkWebProps = {
	number: string;
	className?: string;
	orangeLink?: boolean;
};

export const PhoneLinkWeb: React.FC<PhoneLinkWebProps> = (props: PhoneLinkWebProps) => {
	if (!props.number) return null;
	return (
		<span
			className={clsx(
				"inner-link d-inline-flex align-items-center",
				props.className,
				props.orangeLink && "orange-link",
				!props.orangeLink && "gray-link"
			)}
		>
			<i
				className="im im-phone"
				style={{ fontSize: "10px", marginRight: "3px", marginTop: "1px", marginLeft: "-1px" }}
			></i>
			<PhoneLink number={formatPhoneNumber(props.number)} />
		</span>
	);
};
